"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RefAuditReasonKey = exports.RefAuditCategory = exports.RefAuditAction = void 0;
var RefAuditAction;
(function (RefAuditAction) {
    RefAuditAction["Create"] = "CREATE";
    RefAuditAction["Update"] = "UPDATE";
    RefAuditAction["Delete"] = "DELETE";
    RefAuditAction["Read"] = "READ";
})(RefAuditAction = exports.RefAuditAction || (exports.RefAuditAction = {}));
var RefAuditCategory;
(function (RefAuditCategory) {
    RefAuditCategory["CrfData"] = "CRF:DATA";
    RefAuditCategory["CrfQuery"] = "CRF:QUERY";
    RefAuditCategory["CrfItemSdv"] = "CRF:ITEM:SDV";
    RefAuditCategory["CrfItemFreezing"] = "CRF:ITEM:FREEZING";
    RefAuditCategory["CrfItemLocking"] = "CRF:ITEM:LOCKING";
    RefAuditCategory["CrfSdv"] = "CRF:SDV";
    RefAuditCategory["CrfFreezing"] = "CRF:FREEZING";
    RefAuditCategory["CrfEsign"] = "CRF:ESIGN";
    RefAuditCategory["CrfLocking"] = "CRF:LOCKING";
})(RefAuditCategory = exports.RefAuditCategory || (exports.RefAuditCategory = {}));
var RefAuditReasonKey;
(function (RefAuditReasonKey) {
    RefAuditReasonKey["StudySubjectCreate"] = "STUDY_SUBJECT_CREATE";
    RefAuditReasonKey["StudySubjectInitializationStatusUpdatedToProcessing"] = "STUDY_SUBJECT_INITIALIZATION_STATUS_UPDATED_TO_PROCESSING";
    RefAuditReasonKey["StudySubjectInitializationStatusUpdatedToProcessed"] = "STUDY_SUBJECT_INITIALIZATION_STATUS_UPDATED_TO_PROCESSED";
    RefAuditReasonKey["StudySubjectInitializationStatusUpdatedToFail"] = "STUDY_SUBJECT_INITIALIZATION_STATUS_UPDATED_TO_FAIL";
    //
    RefAuditReasonKey["StudySubjectMigrate"] = "STUDY_SUBJECT_MIGRATE";
    RefAuditReasonKey["StudySubjectInit"] = "STUDY_SUBJECT_INIT";
    RefAuditReasonKey["StudySubjectVisitAdd"] = "STUDY_SUBJECT_VISIT_ADD";
    RefAuditReasonKey["StudySubjectVisitRemove"] = "STUDY_SUBJECT_VISIT_REMOVE";
    RefAuditReasonKey["StudySubjectVisitInit"] = "STUDY_SUBJECT_VISIT_INIT";
    RefAuditReasonKey["StudySubjectCrfInit"] = "STUDY_SUBJECT_CRF_INIT";
    //
    RefAuditReasonKey["StudySubjectSubjectNoUpdated"] = "STUDY_SUBJECT_SUBJECT_NO_UPDATED";
    RefAuditReasonKey["StudySubjectAllocated"] = "STUDY_SUBJECT_ALLOCATED";
    RefAuditReasonKey["StudySubjectRandomized"] = "STUDY_SUBJECT_RANDOMIZED";
    RefAuditReasonKey["StudySubjectAgeUpdated"] = "STUDY_SUBJECT_AGE_UPDATED";
    RefAuditReasonKey["StudySubjectSexUpdated"] = "STUDY_SUBJECT_SEX_UPDATED";
    RefAuditReasonKey["StudySubjectBirthDateUpdated"] = "STUDY_SUBJECT_BIRTH_DATE_UPDATED";
    RefAuditReasonKey["StudySubjectIcfApprovedDateUpdated"] = "STUDY_SUBJECT_ICF_APPROVED_DATE_UPDATED";
    RefAuditReasonKey["StudySubjectECoaAccessCodeUpdated"] = "STUDY_SUBJECT_ECOA_ACCESS_CODE_UPDATED";
    RefAuditReasonKey["StudySubjectStatusUpdatedToRegistration"] = "STUDY_SUBJECT_STATUS_UPDATE_TO_REGISTRATION";
    RefAuditReasonKey["StudySubjectStatusUpdatedToEnrolled"] = "STUDY_SUBJECT_STATUS_UPDATE_TO_ENROLLED";
    RefAuditReasonKey["StudySubjectStatusUpdatedToScreening"] = "STUDY_SUBJECT_STATUS_UPDATE_TO_SCREENING";
    RefAuditReasonKey["StudySubjectStatusUpdatedToScreeningFailed"] = "STUDY_SUBJECT_STATUS_UPDATE_TO_SCREENING_FAILED";
    RefAuditReasonKey["StudySubjectStatusUpdatedToOngoing"] = "STUDY_SUBJECT_STATUS_UPDATE_TO_ONGOING";
    RefAuditReasonKey["StudySubjectStatusUpdatedToDroppedOut"] = "STUDY_SUBJECT_STATUS_UPDATE_TO_DROPPED_OUT";
    RefAuditReasonKey["StudySubjectStatusUpdatedToCompleted"] = "STUDY_SUBJECT_STATUS_UPDATE_TO_COMPLETED";
    RefAuditReasonKey["StudySubjectVisitDateUpdated"] = "STUDY_SUBJECT_VISIT_DATE_UPDATED";
    RefAuditReasonKey["StudySubjectReservedUpdated"] = "STUDY_SUBJECT_RESERVED_UPDATED";
    //
    RefAuditReasonKey["StudySubjectEdcDataCaptured"] = "STUDY_SUBJECT_EDC_DATA_CAPTURED";
    RefAuditReasonKey["StudySubjectEdcDataStriked"] = "STUDY_SUBJECT_EDC_DATA_STRIKED";
    RefAuditReasonKey["StudySubjectEdcDataUnStriked"] = "STUDY_SUBJECT_EDC_DATA_UN_STRIKED";
    //
    RefAuditReasonKey["StudySubjectTriggerInvokeAllExplicitly"] = "STUDY_SUBJECT_TRIGGER_INVOKE_ALL_EXPLICITLY";
    RefAuditReasonKey["StudySubjectQueryDeprecated"] = "STUDY_SUBJECT_QUERY_DEPRECATED";
    RefAuditReasonKey["StudySubjectCrfRefresh"] = "STUDY_SUBJECT_CRF_REFRESH";
    //
    RefAuditReasonKey["StudySubjectEdcSdvAutoRelease"] = "STUDY_SUBJECT_EDC_SDV_AUTO_RELEASE";
    RefAuditReasonKey["StudySubjectEdcEsignAutoRelease"] = "STUDY_SUBJECT_EDC_ESIGN_AUTO_RELEASE";
    //
    RefAuditReasonKey["StudySubjectSigningStatusChanged"] = "STUDY_SUBJECT_SIGNING_STATUS_CHANGED";
    //
    RefAuditReasonKey["StudySubjectUnblindRequest"] = "STUDY_SUBJECT_UNBLIND_REQUEST";
    RefAuditReasonKey["StudySubjectUnblindApprove"] = "STUDY_SUBJECT_UNBLIND_APPROVE";
    RefAuditReasonKey["StudySubjectUnblindForceUnderConds"] = "STUDY_SUBJECT_UNBLIND_FORCE_UNDER_CONDITIONS";
    RefAuditReasonKey["StudySubjectUnblindForce"] = "STUDY_SUBJECT_UNBLIND_FORCE";
    //
    RefAuditReasonKey["EcoaDataCaptured"] = "ECOA_DATA_CAPTURED";
    //
    RefAuditReasonKey["StudyIpDeliveryAutoRequested"] = "STUDY_IP_DELIVERY_AUTO_REQUESTED";
    RefAuditReasonKey["StudyIpDeliveryRequested"] = "STUDY_IP_DELIVERY_REQUESTED";
    RefAuditReasonKey["StudyIpDeliveryApproved"] = "STUDY_IP_DELIVERY_APPROVED";
    RefAuditReasonKey["StudyIpDeliveryStarted"] = "STUDY_IP_DELIVERY_STARTED";
    RefAuditReasonKey["StudyIpDeliveryCanceled"] = "STUDY_IP_DELIVERY_CANCELED";
    RefAuditReasonKey["StudyIpDeliveryConfirmed"] = "STUDY_IP_DELIVERY_CONFIRMED";
    //
    RefAuditReasonKey["StudyIpReturnRequested"] = "STUDY_IP_RETURN_REQUESTED";
    RefAuditReasonKey["StudyIpReturnCanceled"] = "STUDY_IP_RETURN_CANCELED";
    RefAuditReasonKey["StudyIpReturnConfirmed"] = "STUDY_IP_RETURN_CONFIRMED";
    //
    RefAuditReasonKey["StudySubjectContactCreate"] = "STUDY_SUBJECT_CONTACT_CREATE";
    RefAuditReasonKey["StudySubjectContactUpdated"] = "STUDY_SUBJECT_CONTACT_UPDATED";
    RefAuditReasonKey["StudySubjectContactDeleted"] = "STUDY_SUBJECT_CONTACT_DELETED";
})(RefAuditReasonKey = exports.RefAuditReasonKey || (exports.RefAuditReasonKey = {}));
//# sourceMappingURL=resource.js.map